import { doesSelectedProjectRequireFuneral } from '~loader/loader-utils';
import { getState } from '~src/state';

export const getMetadata = () => {
  const requiresFuneral = doesSelectedProjectRequireFuneral();
  const servizio = getState('selected.servizio');
  const projectType = getState('selected.tipo');
  const format = getState('selected.formato');
  const formatDefault = getState('selected.formatoDefault');
  const templatesCategory = getState('selected.templatesCategory');

  const metadata = {};

  if (projectType.name) {
    metadata.projectTypeName = projectType.name;
  }

  if (format?.name || formatDefault?.name) {
    metadata.formatName = format?.name || formatDefault?.name;
  }

  if (templatesCategory && templatesCategory.name) {
    metadata.templatesCategoryName = templatesCategory.name;
  }

  if (requiresFuneral && servizio) {
    metadata.servizioName = `${servizio.cognome} ${servizio.nome}`;
    metadata.servizioId = servizio.objectId;
  }
  return metadata;
};
